import { Route, Routes, useParams } from 'react-router-dom';

import { OrderProvider } from 'contexts/OrderContext';

import { paths } from 'data/routes';

import { DefaultLayout } from 'layouts/DefaultLayout';

import { List } from './components/List';
import { Order } from './components/Order';

function OrderRoute() {
  const { id } = useParams();
  return (
    <DefaultLayout>
      <OrderProvider key={id}>
        <Order />
      </OrderProvider>
    </DefaultLayout>
  );
}

export function OrdersPage(): React.ReactElement {
  return (
    <Routes>
      <Route path={paths.viewOrders}>
        <Route
          index
          element={
            <DefaultLayout isNested withHeader>
              <List />
            </DefaultLayout>
          }
        />

        <Route path="order/:id" element={<OrderRoute />} />
      </Route>
    </Routes>
  );
}
